const mapOrderStatusFromApi = (apiStatus: ApiOrderStatus): OrderStatus => {
  return {
    code: apiStatus.name,
    description: apiStatus.title_front,
    isHighlighted: apiStatus.is_highlighted,
    color: apiStatus.color,
  };
};

export default mapOrderStatusFromApi;
